import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { UserState } from '../types';

const selectDomain = (state?: RootState) => state?.questionnaireListState || UserState;

export const selectLoading = createSelector(
  [selectDomain],
  state => state.loading,
);
export const selectList = createSelector([selectDomain], state => state.list);
export const selectQuery = createSelector([selectDomain], state => state.query);
export const selectQuestionnaire = createSelector(
  [selectDomain],
  state => state.form.questionnaire,
);
export const selectError = createSelector([selectDomain], state => state.error);
